import { Reveal } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

const NUMS = ["01", "02", "03", "04"];

export const HowItWorks = () => {
  const { t } = useI18n();
  const chapters = t("how.chapters");
  return (
    <section id="how" className="relative py-28 md:py-36 px-6 bg-[#05101f]">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <p className="font-mono text-[13px] tracking-[0.3em] uppercase text-[#4BE3FF] mb-5">
            {t("how.kicker")}
          </p>
          <h2 className="font-display font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">
            {t("how.title")}
          </h2>
        </Reveal>

        <div className="mt-20 divide-y divide-white/10 border-t border-white/10">
          {chapters.map((c, i) => (
            <Reveal key={NUMS[i]} delay={i * 0.05}>
              <div
                data-testid={`chapter-${NUMS[i]}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 items-start"
              >
                <div className="md:col-span-3">
                  <span className="font-display font-black text-7xl md:text-8xl text-transparent bg-clip-text bg-gradient-to-b from-[#A7B4C2] to-transparent group-hover:from-[#4BE3FF] transition-colors duration-500">
                    {NUMS[i]}
                  </span>
                </div>
                <h3 className="md:col-span-4 font-display font-semibold text-2xl md:text-3xl text-white pt-4">
                  {c.title}
                </h3>
                <p className="md:col-span-5 font-ui text-[15px] md:text-base text-[#A7B4C2] leading-relaxed pt-4">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
